module.exports = __webpack_public_path__ + "img/1573086912.0c71b2f4.jpg";